export default __webpack_public_path__ + "static/before-1c317a535705d0101fe4e8b4b41a6ee8.jpg";